/* Offer-Test Produktseite, Testgruppe B („Entwurf A Final“, 9.10.2026).
   Läuft auf der Produktseite mit dem Template product.variation-pdp-new. Seit 14.10.2026 fest eingebaut: <html> trägt dort immer
   die Klasse ho3-b (layout/theme.liquid). Markup: snippets/ho3-pdp-b.liquid. */
(function () {
  'use strict';
  if (window.__ho3PdpB) return;
  window.__ho3PdpB = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  // Geld: 449 -> „449€“, 149.67 -> „149,67€“ (wie das Theme)
  function geld(euro) {
    var gerundet = Math.round(euro * 100) / 100;
    return (gerundet % 1 === 0 ? String(gerundet) : gerundet.toFixed(2).replace('.', ',')) + '€';
  }
  function zahlAus(text) {
    var m = String(text || '').replace(/\s/g, '').replace(/\./g, '').match(/(\d+)(?:,(\d{1,2}))?/);
    return m ? parseFloat(m[1] + '.' + (m[2] || '0')) : 0;
  }

  /* ---------- Preis: Garantie, Button, Sticky, Raten, Storys ---------- */
  var form = $('.pdp-figma form.product-purchase-form');
  var knopf = form ? form.querySelector('button[data-add-to-cart-text]') : null;
  var check = $('.a2-upgrade__check[data-ho3b-garantie]');
  var gPreis = check ? (parseInt(check.getAttribute('data-ho3b-garantie-preis'), 10) || 0) / 100 : 0;
  var zuletztGesetzt = null;

  function basisPreis() {
    var el = $('.pdp-figma .price-area .current-price');
    return el ? zahlAus(el.textContent) : 0;
  }
  function preiseSetzen() {
    var basis = basisPreis();
    if (!basis) return;
    var plus = check && check.checked ? gPreis : 0;
    var rate = Math.ceil((basis + plus) * 100 / 3) / 100;
    $$('[data-ho3b-rate]').forEach(function (e) { e.textContent = geld(rate); });
    $$('.a-story').forEach(function (s) { s.setAttribute('data-preis', geld(basis + plus)); });
    if (knopf && !knopf.disabled) {
      var soll = geld(basis + plus);
      if (knopf.getAttribute('data-pdp-price') !== soll) { zuletztGesetzt = soll; knopf.setAttribute('data-pdp-price', soll); }
    }
  }
  if (knopf) {
    // Das Theme schreibt den Button-Preis bei jedem Variantenwechsel neu; danach Garantie wieder aufschlagen.
    new MutationObserver(function () {
      if (knopf.getAttribute('data-pdp-price') !== zuletztGesetzt) preiseSetzen();
    }).observe(knopf, { attributes: true, attributeFilter: ['data-pdp-price', 'disabled'] });
  }
  document.addEventListener('change', function (e) {
    if (e.target === check || (e.target.matches && e.target.matches('.option-selector input'))) setTimeout(preiseSetzen, 80);
  });

  // Garantie mit in den Warenkorb: erst das Garantie-Produkt, dann der normale Ablauf des Themes (öffnet den Drawer)
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!check || !check.checked || f !== form) return;
    if (f.getAttribute('data-ho3b-garantie-laeuft')) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    f.setAttribute('data-ho3b-garantie-laeuft', '1');
    var weiter = function () {
      try {
        if (window.jQuery) window.jQuery(f).trigger('submit');
        else if (f.requestSubmit) f.requestSubmit(); else f.submit();
      } finally {
        setTimeout(function () { f.removeAttribute('data-ho3b-garantie-laeuft'); }, 0);
      }
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(check.getAttribute('data-ho3b-garantie'), 10), quantity: 1 }] })
    }).then(weiter, weiter);
  }, true);

  /* ---------- Pop-up Garantiebedingungen ---------- */
  var bed = $('[data-ho3b-bed]');
  var bedAusloeser = null;
  if (bed) document.body.appendChild(bed); // aus der Kaufbox lösen, damit fixed sauber über allem liegt
  function bedOeffnen(k) { if (!bed) return; bedAusloeser = k; bed.hidden = false; document.documentElement.classList.add('ho3b-bed-offen'); var z = $('.a2-bed__zu', bed); if (z) z.focus({ preventScroll: true }); }
  function bedSchliessen() { if (!bed || bed.hidden) return; bed.hidden = true; document.documentElement.classList.remove('ho3b-bed-offen'); if (bedAusloeser) bedAusloeser.focus({ preventScroll: true }); }
  document.addEventListener('click', function (e) {
    var k = e.target.closest && e.target.closest('[data-ho3b-bedingungen]');
    if (k) { e.preventDefault(); e.stopPropagation(); bedOeffnen(k); return; }
    if (bed && !bed.hidden && (e.target === bed || (e.target.closest && e.target.closest('.a2-bed__zu')))) bedSchliessen();
  }, true);

  /* ---------- Pop-up gesetzliche Gewährleistung (EU-Hinweis, 14.10.2026) ---------- */
  var gw = $('[data-ho3b-gw-pop]');
  var gwAusloeser = null;
  if (gw) document.body.appendChild(gw);
  function gwOeffnen(k) {
    if (!gw) return false;
    var bild = $('img[data-ho3b-src]', gw);
    if (bild && !bild.getAttribute('src')) bild.setAttribute('src', bild.getAttribute('data-ho3b-src')); // Grafik erst beim Öffnen laden (eigenes Attribut, data-src lädt das Theme sofort)
    gwAusloeser = k; gw.hidden = false; document.documentElement.classList.add('ho3b-bed-offen');
    var z = $('.a2-bed__zu', gw); if (z) z.focus({ preventScroll: true });
    return true;
  }
  function gwSchliessen() {
    if (!gw || gw.hidden) return;
    gw.hidden = true; document.documentElement.classList.remove('ho3b-bed-offen');
    if (gwAusloeser) gwAusloeser.focus({ preventScroll: true });
  }
  document.addEventListener('click', function (e) {
    var k = e.target.closest && e.target.closest('[data-ho3b-gw]');
    if (k) { if (gwOeffnen(k)) e.preventDefault(); return; }
    if (gw && !gw.hidden && (e.target === gw || (e.target.closest && e.target.closest('[data-ho3b-gw-zu]')))) gwSchliessen();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') gwSchliessen(); });

  /* ---------- Literpreis: Rechnung auf- und zuklappen ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.a2-liter__info');
    if (!b) return;
    e.preventDefault();
    var r = document.getElementById('ho3b-liter-rechnung');
    if (!r) return;
    var auf = r.hidden;
    r.hidden = !auf;
    b.setAttribute('aria-expanded', String(auf));
  });

  /* ---------- Bewertungen: zur Bewertungs-Section scrollen ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-ho3b-bewertungen]');
    if (!a) return;
    var ziel = $('[id$="__17362854380c1c3a16"]') || $('#klaviyo-reviews-all') || $('[id*="ho3_kundenstimmen"]');
    if (!ziel) return;
    e.preventDefault();
    ziel.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------- Lieferzeit: Text aus der Delm-App als ruhige Zeilen ---------- */
  // Delm rendert im Shadow DOM (von außen nicht gestaltbar). Text auslesen, im Info-Block nachbauen, Delm ausblenden.
  // Klappt das nicht, bleibt die originale Delm-Zeile sichtbar (kein Inhalt verloren).
  var delmZiel = $('[data-ho3b-delm]');
  var delmLetzt = '';
  var LKW = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6.5h10.5v9H3zM13.5 9.5h4l3 3.2v2.8h-7" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><circle cx="7" cy="17.2" r="1.8" fill="#fff" stroke="currentColor" stroke-width="1.6"/><circle cx="17" cy="17.2" r="1.8" fill="#fff" stroke="currentColor" stroke-width="1.6"/></svg>';
  var WARN = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M12 7.5v5.5" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/><circle cx="12" cy="16.4" r="1.1" fill="currentColor"/></svg>';
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function delmLesen() {
    var w = $('[data-pdp-block*="delm_"] delm-widget');
    var root = w && w.shadowRoot;
    if (!root) return false;
    var text = (root.textContent || '').replace(/\s+/g, ' ').trim();
    var lief = (text.match(/Lieferung erfolgt (zwischen .*?)(?= Bei Bestellung|$)/) || [])[1] || '';
    if (!lief) return false;
    var frist = (text.match(/Bei Bestellung innerhalb (.*?)$/) || [])[1] || '';
    var knapp = /Wenige Einheiten/.test(text);
    var html = '';
    // 22.10.2026: Bei den Farben aus data-knapp-farben (Schwarz) roter Kasten mit fast leerem Balken und Lieferzeit-Hinweis statt der Punkt-Zeile
    var farbeEl = $('.pdp-figma .option-selector input[type="radio"]:checked');
    var farbe = farbeEl ? String(farbeEl.value || '').trim() : '';
    var knappFarben = (delmZiel.getAttribute('data-knapp-farben') || '').toLowerCase().split(',').map(function (f) { return f.trim(); });
    if (knapp && farbe && knappFarben.indexOf(farbe.toLowerCase()) > -1) {
      // Überschrift und Balken sind optional (27.10.2026: beide aus, dann Ausrufezeichen direkt am Hinweis)
      var fuellung = parseInt(delmZiel.getAttribute('data-knapp-fuellung'), 10) || 0;
      var titel = (delmZiel.getAttribute('data-knapp-titel') || '').replace('[farbe]', farbe);
      html += '<div class="a2-knapp">' +
        (titel ? '<p class="a2-knapp__titel">' + WARN + esc(titel) + '</p>' : '') +
        (fuellung > 0 ? '<div class="a2-knapp__balken" aria-hidden="true"><span style="width:' + fuellung + '%"></span></div>' : '') +
        '<p class="a2-knapp__text' + (titel ? '' : ' a2-knapp__text--symbol') + '">' + (titel ? '' : WARN) + esc(delmZiel.getAttribute('data-knapp-text') || '') + '</p></div>';
    }
    // 27.10.2026: Die Zeile „Wenige Einheiten verfügbar“ (roter Punkt) bei den übrigen Farben ist raus (Benedikt)
    html += '<div class="a2-info__zeile">' + LKW + '<p>Lieferung zwischen <strong>' + esc(lief.replace(/^zwischen /, '')) + '</strong>' +
      (frist ? '<small>Bei Bestellung innerhalb <strong>' + esc(frist) + '</strong></small>' : '') + '</p></div>';
    // nur bei echter Änderung neu schreiben (innerHTML-Vergleich griff wegen der SVG-Schreibweise nie, 22.10.2026)
    if (delmLetzt !== html) { delmLetzt = html; delmZiel.innerHTML = html; }
    document.documentElement.classList.add('ho3b-delm-ok');
    return root;
  }
  if (delmZiel) {
    var versuche = 0, beobachtet = false;
    (function warten() {
      var root = delmLesen();
      if (root && !beobachtet) {
        beobachtet = true;
        // Delm aktualisiert Frist und Variante im Shadow DOM: nachziehen
        new MutationObserver(function () { delmLesen(); }).observe(root, { childList: true, subtree: true, characterData: true });
      }
      if (!root && versuche++ < 40) setTimeout(warten, 250);
    })();
    // Farbwechsel: Kasten sofort passend zur neuen Farbe (Delm zieht das Datum kurz danach nach)
    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('.pdp-figma .option-selector input')) { setTimeout(delmLesen, 60); setTimeout(delmLesen, 600); }
    });
  }

  /* ---------- Story-Player ---------- */
  var ICON = {
    ton: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4z"/><path d="M15.5 9a4.5 4.5 0 0 1 0 6M18.2 6.5a8 8 0 0 1 0 11"/></svg>',
    stumm: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4z"/><path d="M16 9.5l5 5M21 9.5l-5 5"/></svg>',
    zu: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    links: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M14.5 6l-6 6 6 6"/></svg>',
    rechts: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M9.5 6l6 6-6 6"/></svg>'
  };
  var liste = [], idx = 0, ov = null, vid = null, buehne = null, stumm = false, raf = 0, ausloeser = null;
  var DAUER_ERSATZ = 30;

  function sammeln() {
    liste = $$('.a-story').map(function (b) {
      return { el: b, clip: b.getAttribute('data-clip'), poster: b.getAttribute('data-poster'), bild: b.getAttribute('data-bild'),
        name: b.getAttribute('data-name'), label: b.getAttribute('data-label') || '', titel: b.getAttribute('data-titel'), preis: b.getAttribute('data-preis') || '' };
    });
  }
  function bauen() {
    ov = document.createElement('div');
    ov.className = 'a-player';
    ov.hidden = true;
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.setAttribute('aria-label', 'Home One im Alltag, Videos');
    ov.innerHTML =
      '<button type="button" class="a-player__pfeil a-player__pfeil--l" data-a="zurueck" aria-label="Vorheriges Video">' + ICON.links + '</button>' +
      '<div class="a-player__buehne">' +
        '<video class="a-player__video" playsinline webkit-playsinline preload="auto"></video>' +
        '<div class="a-player__balken">' + liste.map(function () { return '<span><i></i></span>'; }).join('') + '</div>' +
        '<div class="a-player__kopf"><img class="a-player__avatar" alt="">' +
          '<div class="a-player__wer"><p class="a-player__name"><span class="a-player__n"></span><span class="a-player__label"></span></p><p class="a-player__titel"></p></div>' +
          '<button type="button" class="a-player__knopf a-player__ton" data-a="ton" aria-label="Ton aus">' + ICON.ton + '</button>' +
          '<button type="button" class="a-player__knopf a-player__zu" data-a="zu" aria-label="Schließen">' + ICON.zu + '</button></div>' +
        '<button type="button" class="a-player__zone a-player__zurueck" data-a="zurueck" aria-label="Vorheriges Video"></button>' +
        '<button type="button" class="a-player__zone a-player__weiter" data-a="weiter" aria-label="Nächstes Video"></button>' +
        '<div class="a-player__fuss"><button type="button" class="a-player__kaufen" data-a="kaufen"></button></div>' +
      '</div>' +
      '<button type="button" class="a-player__pfeil a-player__pfeil--r" data-a="weiter" aria-label="Nächstes Video">' + ICON.rechts + '</button>';
    document.body.appendChild(ov);
    vid = $('video', ov);
    buehne = $('.a-player__buehne', ov);
    vid.addEventListener('ended', weiter);
    ov.addEventListener('click', function (e) {
      var a = e.target.closest('[data-a]');
      if (!a) return;
      var was = a.getAttribute('data-a');
      if (was === 'zurueck') zurueck();
      else if (was === 'weiter') weiter();
      else if (was === 'ton') tonUmschalten();
      else if (was === 'zu') schliessen();
      else if (was === 'kaufen') kaufen();
    });
  }
  function balken() {
    var bs = $$('.a-player__balken i', ov);
    bs.forEach(function (b, j) { b.style.width = j < idx ? '100%' : '0%'; });
    var dauer = (vid.duration && isFinite(vid.duration)) ? vid.duration : DAUER_ERSATZ;
    if (bs[idx]) bs[idx].style.width = Math.min(100, ((vid.currentTime || 0) / dauer) * 100) + '%';
  }
  function schleife() { balken(); raf = requestAnimationFrame(schleife); }
  function tonAnzeigen() {
    var k = $('.a-player__ton', ov);
    k.innerHTML = stumm ? ICON.stumm : ICON.ton;
    k.setAttribute('aria-label', stumm ? 'Ton an' : 'Ton aus');
  }
  function tonUmschalten() { stumm = !stumm; vid.muted = stumm; tonAnzeigen(); if (vid.paused) vid.play().catch(function () {}); }
  function zeigen(i) {
    idx = i;
    var s = liste[i];
    vid.pause();
    buehne.style.backgroundImage = s.poster ? 'url("' + s.poster + '")' : '';
    vid.poster = s.poster || '';
    vid.src = s.clip;
    vid.muted = stumm;
    $('.a-player__avatar', ov).src = s.bild;
    $('.a-player__n', ov).textContent = s.name;
    $('.a-player__label', ov).textContent = s.label;
    $('.a-player__titel', ov).textContent = s.titel;
    $('.a-player__kaufen', ov).textContent = 'In den Warenkorb' + (s.preis ? ' · ' + s.preis : '');
    s.el.classList.add('is-gesehen');
    balken();
    var p = vid.play();
    if (p && p.catch) p.catch(function () {
      // Browser blockt Ton ohne Geste: stumm weiterspielen, Ton-Knopf zeigt „aus“
      stumm = true; vid.muted = true; tonAnzeigen();
      vid.play().catch(function () { vid.addEventListener('canplay', function () { vid.play().catch(function () {}); }, { once: true }); });
    });
  }
  function oeffnen(i, k) {
    sammeln();
    if (!liste.length) return;
    if (!ov || $$('.a-player__balken span', ov).length !== liste.length) { if (ov) ov.remove(); bauen(); }
    ausloeser = k || null;
    ov.hidden = false;
    document.documentElement.classList.add('a-player-offen');
    tonAnzeigen();
    zeigen(i);
    cancelAnimationFrame(raf); schleife();
    $('.a-player__zu', ov).focus({ preventScroll: true });
  }
  function schliessen() {
    if (!ov || ov.hidden) return;
    vid.pause(); vid.removeAttribute('src'); vid.load();
    cancelAnimationFrame(raf);
    ov.hidden = true;
    document.documentElement.classList.remove('a-player-offen');
    if (ausloeser) ausloeser.focus({ preventScroll: true });
  }
  function weiter() { if (idx < liste.length - 1) zeigen(idx + 1); else schliessen(); }
  function zurueck() { if (idx > 0) zeigen(idx - 1); else { vid.currentTime = 0; vid.play().catch(function () {}); } }
  function kaufen() {
    schliessen();
    if (!knopf || knopf.disabled) return;
    knopf.scrollIntoView({ block: 'center', behavior: 'smooth' });
    knopf.click(); // gleicher Weg wie der Kaufbutton (inklusive Garantie, falls angehakt)
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.a-story');
    if (!b) return;
    e.preventDefault();
    oeffnen(parseInt(b.getAttribute('data-i'), 10) || 0, b);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { bedSchliessen(); schliessen(); return; }
    if (!ov || ov.hidden) return;
    if (e.key === 'ArrowRight') weiter();
    else if (e.key === 'ArrowLeft') zurueck();
  });

  // Start
  preiseSetzen();
})();
